import { Column, CreateDateColumn, Entity, Index, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { Grn } from "../grn/grn.entity";
import { GrnItemReturns } from "./grn-item-return-entity";

@Entity("grn_returns", { schema: "erp_procurement" })
export class GrnReturns {
    @PrimaryGeneratedColumn({ type: "int", name: "grn_return_id", comment: "Grn return id" })
    grnReturnId: number;

    @Column({ name: "grn_return_date", nullable: false })
    grnReturnDate: Date;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "grn_return_number"
    })
    grnReturnNumber: string;

    @Column("varchar", {
        nullable: true,
        length: 30,
        name: "remarks"
    })
    remarks: string;

    @Column("int", {
        nullable: false,
        name: "plant_id"
    })
    plantId: number;

    @CreateDateColumn({ name: "created_at" })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        length: 40,
        name: "created_user"
    })
    createdUser: string | null;

    @UpdateDateColumn({ name: "updated_at" })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @ManyToOne(type => Grn, grn => grn.grnReturnInfo, { nullable: false, })
    @JoinColumn({ name: "grn_id" })
    grnId: Grn;

    @OneToMany(type => GrnItemReturns, grnItems => grnItems.grnReturnInfo, { cascade: true })
    grnReturnItemsInfo: GrnItemReturns[];
}